// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__gFZvx","requiredAsterisk":"Info_requiredAsterisk__3fNeH"};